import script from "./ManagedByDevpostCheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagedByDevpostCheckBox.vue?vue&type=script&setup=true&lang=js"

import "./ManagedByDevpostCheckBox.vue?vue&type=style&index=0&id=732d531e&scoped=true&lang=scss"
script.__scopeId = "data-v-732d531e"

export default script